<template>
  <div class="bankeys-footer">
    <img :src="require('@/assets/images/esign-logo.svg')" alt="" class="esign-logo" />
    <span class="footer-text">由e签宝提供技术支持</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.bankeys-footer {
  height: 32px;
  text-align: center;
  width: 100%;
  background-color: #f7f8fa;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  border-top: 1px solid #e4e4e4;
  font-size: 12px;
  color: #999;
  .esign-logo {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 4px;
  }
  .footer-text {
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    line-height: 32px;
  }
}
@media (max-width: 768px) {
  .bankeys-footer {
    background: #fff;
    border: none;
    height: 17px;
    color: #ccc;
    margin-bottom: 24px;
    .esign-logo {
      width: 10px;
      height: 10px;
    }
    .footer-text {
      line-height: 17px;
    }
  }
}
</style>
